// You can customize below settings :)
const settings = {
  title: '伯恩SRM',
  showSettings: false,
  showTagsView: true,
  fixedHeader: false,
  showSidebarLogo: true,
  // errorLog: ['production'],
  // errorLog: ['development'], // '哪个环境开启错日志功能',或捕获vue错误，不在控制台显示
  errorLog: [],
  sidebarTextTheme: true,
  devServerPort: 9527,
  mockServerPort: 9528
};
export default settings;